import './loaderCard.scss';
const LoaderCard = () => {
  return (
    <div id="loaderCard">
      <div className="boxCountryCard">
        <div className="flagContainer">
          <div className="flagBox fullSkeleton" />
        </div>
        <div className="rateContainer">
          <div className="containerRateInput">
            <div className="labelCountryInput" />
            <div className="inputCountry fullSkeleton allH" style={{ width: '80px' }} />
          </div>
        </div>
        <div className="taxesContainer">
          <div className="containerTaxesInput">
            <div className="labelCountryInput" />
            <div className="inputCountry fullSkeleton  allH" style={{ width: '80px' }} />
          </div>
        </div>
        <div className="indicativeContainer">
          <div className="containerIndicativeInput">
            <div className="labelCountryInput" />
            <div className="inputCountry fullSkeleton allH" style={{ width: '80px' }} />
          </div>
        </div>
        <div className="documentContainer">
          <div className="containerDocumentInput">
            <div className="labelCountryInput uppercase" />
            <div className="inputCountry">
              <div className="inputCountry fullSkeleton allH" style={{ width: '180px' }} />
            </div>
          </div>
        </div>
        <div className="providerContainer">
          <div className="containerProviderInput">
            <div className="labelCountryInput" />
            <div className="fullSkeleton allH" style={{ width: '180px' }} />
          </div>
        </div>
        <div className="registerContainer">
          <div className="genericCheck fullSkeleton" />
        </div>
        <div className="buyContainer">
          <div className="genericCheck fullSkeleton" />
        </div>
        <div className="servicesContainer">
          <div className="genericCheck fullSkeleton" />
        </div>
        <div className="saveContainer">
          <div className="saveButton fullSkeleton" style={{ width: '48px' }} />
        </div>
      </div>
    </div>
  );
};

export default LoaderCard;
